<script setup lang="ts">
import { onMounted } from 'vue'
import { useSiteStore } from '@/stores/site'
import type { SelectButtonChangeEvent } from 'primevue'

const siteStore = useSiteStore()

const options = [
  { label: '한국어', value: 'ko' },
  { label: 'English', value: 'en' }
]

function updateLastLocale(event: SelectButtonChangeEvent) {
  localStorage.setItem('lastLocale', event.value)
  location.reload()
}

onMounted(() => {
  const lastLocale = (localStorage.getItem('lastLocale') ?? 'ko') as 'ko' | 'en'

  siteStore.changeLocale(lastLocale)
})
</script>

<template>
  <SelectButton
    v-show="siteStore.siteConfig.supportLocales.length > 1"
    :model-value="$i18n.locale"
    class="locale-btn"
    :options="options"
    option-value="value"
    option-label="label"
    :option-disabled="(option) => option.value === $i18n.locale"
    @change="updateLastLocale" />
</template>

<style lang="postcss">
.locale-btn .p-togglebutton {
  @apply disabled:!bg-[var(--p-togglebutton-background)] disabled:!border-[var(--p-togglebutton-border-color)];
}
</style>
